const data = [
    {
        'rank': 1,
        'city': 'Durham',
        'co2': 6.47,
        'energy': 7.53,
        'air quality': 10,
        'recycling': 4.96,
        'fly tipping': 8.26,
        'litter': 9.39,
        'green space': 9.44,
        'nature reserves': 9.68,
        'car charging': 3.01,
        'traffic congestion': 8.95,
        'total': 7.77
    },
    {
        'rank': 2,
        'city': 'Swansea',
        'co2': 6.5,
        'energy': 7.59,
        'air quality': 6.67,
        'recycling': 10,
        'fly tipping': 9.34,
        'litter': 8.73,
        'green space': 10,
        'nature reserves': 5.16,
        'car charging': 1.08,
        'traffic congestion': '-',
        'total': 7.23
    },
    {
        'rank': 3,
        'city': 'Newcastle upon Tyne',
        'co2': 6.7,
        'energy': 7.83,
        'air quality': 6.67,
        'recycling': 3.89,
        'fly tipping': 5.64,
        'litter': 6.82,
        'green space': 7.73,
        'nature reserves': 10,
        'car charging': 8.82,
        'traffic congestion': 6.45,
        'total': 7.05
    },
    {
        'rank': 4,
        'city': 'Salford',
        'co2': 6.22,
        'energy': 7.63,
        'air quality': '-',
        'recycling': 6.01,
        'fly tipping': 8.67,
        'litter': 9.54,
        'green space': '-',
        'nature reserves': 2.26,
        'car charging': 10,
        'traffic congestion': 5.49,
        'total': 6.98
    },
    {
        'rank': 5,
        'city': 'Worcester',
        'co2': 7.48,
        'energy': 8.51,
        'air quality': 8,
        'recycling': 3.57,
        'fly tipping': 9.76,
        'litter': 9.16,
        'green space': 6.67,
        'nature reserves': 5.81,
        'car charging': 0.97,
        'traffic congestion': 9.18,
        'total': 6.91
    },
    {
        'rank': 6,
        'city': 'Coventry',
        'co2': 7.31,
        'energy': 8.44,
        'air quality': 4.27,
        'recycling': 2.96,
        'fly tipping': 7.57,
        'litter': 8.49,
        'green space': 4.17,
        'nature reserves': 9.03,
        'car charging': 8.06,
        'traffic congestion': 7.92,
        'total': 6.82
    },
    {
        'rank': 7,
        'city': 'Gloucester',
        'co2': 7.37,
        'energy': 8.33,
        'air quality': '-',
        'recycling': 5.09,
        'fly tipping': 8.48,
        'litter': 8.63,
        'green space': '-',
        'nature reserves': 5.48,
        'car charging': 2.37,
        'traffic congestion': 8.76,
        'total': 6.81
    },
    {
        'rank': 8,
        'city': 'Cambridge',
        'co2': 6.79,
        'energy': 7.75,
        'air quality': 5.74,
        'recycling': 6.8,
        'fly tipping': 8.92,
        'litter': 7.77,
        'green space': 8.72,
        'nature reserves': 2.9,
        'car charging': 3.33,
        'traffic congestion': 9.09,
        'total': 6.78
    },
    {
        'rank': 9,
        'city': 'St Albans',
        'co2': 5.03,
        'energy': 6.5,
        'air quality': 4.67,
        'recycling': 9.8,
        'fly tipping': 9.34,
        'litter': 8.27,
        'green space': 7.5,
        'nature reserves': 4.52,
        'car charging': 2.69,
        'traffic congestion': 8.71,
        'total': 6.7
    },
    {
        'rank': 10,
        'city': 'Exeter',
        'co2': 7.58,
        'energy': 8.58,
        'air quality': 7.33,
        'recycling': 1.25,
        'fly tipping': 9.15,
        'litter': 8.51,
        'green space': 7.5,
        'nature reserves': 5.48,
        'car charging': 2.04,
        'traffic congestion': 9.52,
        'total': 6.7
    },
    {
        'rank': 11,
        'city': 'York',
        'co2': 7.01,
        'energy': 8.07,
        'air quality': 8,
        'recycling': 5.28,
        'fly tipping': 9.18,
        'litter': 9.25,
        'green space': 6.19,
        'nature reserves': 1.94,
        'car charging': 4.3,
        'traffic congestion': 7.29,
        'total': 6.65
    },
    {
        'rank': 12,
        'city': 'Bangor',
        'co2': 5.78,
        'energy': 6.85,
        'air quality': 9.07,
        'recycling': 9.85,
        'fly tipping': 9.79,
        'litter': 8.91,
        'green space': 6.67,
        'nature reserves': 2.26,
        'car charging': 0.32,
        'traffic congestion': '-',
        'total': 6.61
    },
    {
        'rank': 13,
        'city': 'Chelmsford',
        'co2': 6.27,
        'energy': 7.49,
        'air quality': 4.67,
        'recycling': 6.43,
        'fly tipping': 9.92,
        'litter': 9.34,
        'green space': 7.22,
        'nature reserves': 4.84,
        'car charging': 0.75,
        'traffic congestion': 8.91,
        'total': 6.58
    },
    {
        'rank': 14,
        'city': 'Bath',
        'co2': 7.25,
        'energy': 8.36,
        'air quality': 1.67,
        'recycling': 8.97,
        'fly tipping': 8.86,
        'litter': 9.72,
        'green space': 7.08,
        'nature reserves': 2.9,
        'car charging': 2.04,
        'traffic congestion': 7.85,
        'total': 6.47
    },
    {
        'rank': 15,
        'city': 'Salisbury',
        'co2': 5.77,
        'energy': 6.98,
        'air quality': 6.67,
        'recycling': 5.35,
        'fly tipping': 9.37,
        'litter': 9.64,
        'green space': 7.22,
        'nature reserves': 2.9,
        'car charging': 0.86,
        'traffic congestion': 9.47,
        'total': 6.42
    },
    {
        'rank': 16,
        'city': 'Hereford',
        'co2': 5.31,
        'energy': 6.46,
        'air quality': 6.67,
        'recycling': 4.72,
        'fly tipping': 9.79,
        'litter': 8.82,
        'green space': 6.67,
        'nature reserves': 4.84,
        'car charging': 0.97,
        'traffic congestion': 10,
        'total': 6.42
    },
    {
        'rank': 17,
        'city': 'Oxford',
        'co2': 6.74,
        'energy': 7.67,
        'air quality': 6.85,
        'recycling': 7.31,
        'fly tipping': 8.68,
        'litter': 1.13,
        'green space': 8.54,
        'nature reserves': 4.19,
        'car charging': 3.44,
        'traffic congestion': 9.07,
        'total': 6.36
    },
    {
        'rank': 18,
        'city': 'Nottingham',
        'co2': 7.44,
        'energy': 8.52,
        'air quality': 3.61,
        'recycling': 1.1,
        'fly tipping': 6.91,
        'litter': 8.79,
        'green space': 6.67,
        'nature reserves': 6.77,
        'car charging': 7.53,
        'traffic congestion': 5.69,
        'total': 6.3
    },
    {
        'rank': 19,
        'city': 'Canterbury',
        'co2': 7.39,
        'energy': 8.26,
        'air quality': 3.87,
        'recycling': 5.94,
        'fly tipping': 9.15,
        'litter': 8.46,
        'green space': 5.67,
        'nature reserves': 3.55,
        'car charging': 1.08,
        'traffic congestion': 8.8,
        'total': 6.22
    },
    {
        'rank': 20,
        'city': 'Derby',
        'co2': 6.72,
        'energy': 7.84,
        'air quality': 6.3,
        'recycling': 4.11,
        'fly tipping': 6.97,
        'litter': 8.64,
        'green space': 7,
        'nature reserves': 5.16,
        'car charging': 2.69,
        'traffic congestion': 6.32,
        'total': 6.17
    },
    {
        'rank': 21,
        'city': 'Bristol',
        'co2': 7.52,
        'energy': 8.59,
        'air quality': 3.96,
        'recycling': 6.21,
        'fly tipping': 7.86,
        'litter': 5.14,
        'green space': 6.79,
        'nature reserves': 5.16,
        'car charging': 6.02,
        'traffic congestion': 4.41,
        'total': 6.17
    },
    {
        'rank': 22,
        'city': 'Peterborough',
        'co2': 6.07,
        'energy': 7.46,
        'air quality': 8.27,
        'recycling': 5.16,
        'fly tipping': 5.22,
        'litter': 6.81,
        'green space': 6,
        'nature reserves': 4.52,
        'car charging': 1.72,
        'traffic congestion': 9.44,
        'total': 6.07
    },
    {
        'rank': 23,
        'city': 'Belfast',
        'co2': 6.61,
        'energy': 10,
        'air quality': 7.11,
        'recycling': 4.45,
        'fly tipping': '-',
        'litter': 9.87,
        'green space': 6.34,
        'nature reserves': 0.97,
        'car charging': 3.01,
        'traffic congestion': '-',
        'total': 6.05
    },
    {
        'rank': 24,
        'city': 'Carlisle',
        'co2': 5.71,
        'energy': 5.86,
        'air quality': 8.95,
        'recycling': 4.72,
        'fly tipping': 8.79,
        'litter': 9.35,
        'green space': 4.44,
        'nature reserves': 1.61,
        'car charging': 1.51,
        'traffic congestion': 9.43,
        'total': 6.04
    },
    {
        'rank': 25,
        'city': 'Dundee',
        'co2': 6.65,
        'energy': 7.64,
        'air quality': 8.38,
        'recycling': 3.3,
        'fly tipping': '-',
        'litter': 9.47,
        'green space': 7.62,
        'nature reserves': 0.32,
        'car charging': 4.73,
        'traffic congestion': '-',
        'total': 6.01
    },
    {
        'rank': 26,
        'city': 'Wakefield',
        'co2': 5.52,
        'energy': 6.84,
        'air quality': 2.92,
        'recycling': 5.72,
        'fly tipping': 8.84,
        'litter': 8.15,
        'green space': '-',
        'nature reserves': 6.13,
        'car charging': 1.4,
        'traffic congestion': 8.55,
        'total': 6.01
    },
    {
        'rank': 27,
        'city': 'Lichfield',
        'co2': 4.71,
        'energy': 6.36,
        'air quality': '-',
        'recycling': 5.62,
        'fly tipping': 9.79,
        'litter': 9.08,
        'green space': '-',
        'nature reserves': 3.23,
        'car charging': 0.22,
        'traffic congestion': 9.05,
        'total': 6.01
    },
    {
        'rank': 28,
        'city': 'Ripon',
        'co2': 4.53,
        'energy': 5.89,
        'air quality': 5.33,
        'recycling': 4.6,
        'fly tipping': 9.55,
        'litter': 8.09,
        'green space': 10,
        'nature reserves': 1.94,
        'car charging': 0.32,
        'traffic congestion': 9.63,
        'total': 5.99
    },
    {
        'rank': 29,
        'city': 'Leicester',
        'co2': 7.33,
        'energy': 8.32,
        'air quality': 7.2,
        'recycling': 4.21,
        'fly tipping': 7.08,
        'litter': 9.23,
        'green space': 4.55,
        'nature reserves': 4.19,
        'car charging': 2.58,
        'traffic congestion': 5.17,
        'total': 5.99
    },
    {
        'rank': 30,
        'city': 'Norwich',
        'co2': 7.26,
        'energy': 8.3,
        'air quality': 7.33,
        'recycling': 3.99,
        'fly tipping': 5.04,
        'litter': 7.27,
        'green space': 6.15,
        'nature reserves': 1.61,
        'car charging': 3.12,
        'traffic congestion': 9.38,
        'total': 5.95
    },
    {
        'rank': 31,
        'city': 'Preston',
        'co2': 6.08,
        'energy': 7.31,
        'air quality': 8.27,
        'recycling': 2.32,
        'fly tipping': 7.44,
        'litter': 7.6,
        'green space': 7.5,
        'nature reserves': 2.26,
        'car charging': 2.15,
        'traffic congestion': 8.49,
        'total': 5.94
    },
    {
        'rank': 32,
        'city': 'Glasgow',
        'co2': 6.86,
        'energy': 7.97,
        'air quality': 5.07,
        'recycling': 1.15,
        'fly tipping': '-',
        'litter': 6.59,
        'green space': 7.75,
        'nature reserves': 1.29,
        'car charging': 9.89,
        'traffic congestion': '-',
        'total': 5.82
    },
    {
        'rank': 33,
        'city': 'Aberdeen',
        'co2': 5.81,
        'energy': 7.09,
        'air quality': 7.76,
        'recycling': 5.35,
        'fly tipping': '-',
        'litter': 9.54,
        'green space': 5,
        'nature reserves': 0.32,
        'car charging': 5.27,
        'traffic congestion': '-',
        'total': 5.77
    },
    {
        'rank': 34,
        'city': 'Lancaster',
        'co2': 6.75,
        'energy': 7.21,
        'air quality': '-',
        'recycling': 5.53,
        'fly tipping': 7.59,
        'litter': 6.11,
        'green space': '-',
        'nature reserves': 2.9,
        'car charging': 1.18,
        'traffic congestion': 8.49,
        'total': 5.72
    },
    {
        'rank': 35,
        'city': 'Brighton & Hove',
        'co2': 7.81,
        'energy': 8.82,
        'air quality': 7.81,
        'recycling': 1.76,
        'fly tipping': 9.23,
        'litter': 2.79,
        'green space': 8,
        'nature reserves': 1.94,
        'car charging': 2.58,
        'traffic congestion': 5.64,
        'total': 5.64
    },
    {
        'rank': 36,
        'city': 'Liverpool',
        'co2': 7.37,
        'energy': 8.34,
        'air quality': 6.94,
        'recycling': 0.39,
        'fly tipping': 4.59,
        'litter': 7.53,
        'green space': 7.17,
        'nature reserves': 2.9,
        'car charging': 5.91,
        'traffic congestion': 5.1,
        'total': 5.63
    },
    {
        'rank': 37,
        'city': 'Chichester',
        'co2': 5.73,
        'energy': 6.13,
        'air quality': 6.67,
        'recycling': 5.99,
        'fly tipping': 9.03,
        'litter': 9.44,
        'green space': '-',
        'nature reserves': 1.29,
        'car charging': 0.32,
        'traffic congestion': '-',
        'total': 5.58
    },
    {
        'rank': 38,
        'city': 'Edinburgh',
        'co2': 6.62,
        'energy': 7.73,
        'air quality': 7.02,
        'recycling': 4.65,
        'fly tipping': '-',
        'litter': 1.78,
        'green space': 7.71,
        'nature reserves': 2.9,
        'car charging': 5.7,
        'traffic congestion': '-',
        'total': 5.51
    },
    {
        'rank': 39,
        'city': 'Leeds',
        'co2': 6.14,
        'energy': 7.38,
        'air quality': 2.92,
        'recycling': 4.08,
        'fly tipping': 4.56,
        'litter': 6.66,
        'green space': 5.64,
        'nature reserves': 4.19,
        'car charging': 5.81,
        'traffic congestion': 7.73,
        'total': 5.51
    },
    {
        'rank': 40,
        'city': 'Winchester',
        'co2': 4.68,
        'energy': 5.94,
        'air quality': '-',
        'recycling': 3.45,
        'fly tipping': 9.3,
        'litter': 7.44,
        'green space': '-',
        'nature reserves': 2.9,
        'car charging': 0.97,
        'traffic congestion': 9.31,
        'total': 5.5
    },
    {
        'rank': 41,
        'city': 'Kingston upon Hull',
        'co2': 6.95,
        'energy': 7.92,
        'air quality': 5.33,
        'recycling': 6.38,
        'fly tipping': 8.09,
        'litter': 4.35,
        'green space': 6.11,
        'nature reserves': 3.55,
        'car charging': 0.86,
        'traffic congestion': 5.35,
        'total': 5.49
    },
    {
        'rank': 42,
        'city': 'Ely',
        'co2': 3.94,
        'energy': 6.9,
        'air quality': 5.74,
        'recycling': 8.17,
        'fly tipping': 8.9,
        'litter': 8.28,
        'green space': '-',
        'nature reserves': 1.61,
        'car charging': 0.22,
        'traffic congestion': '-',
        'total': 5.47
    },
    {
        'rank': 43,
        'city': 'Inverness',
        'co2': 10,
        'energy': 5,
        'air quality': 8.17,
        'recycling': 5.28,
        'fly tipping': '-',
        'litter': 9.43,
        'green space': 5,
        'nature reserves': 0.32,
        'car charging': 0.54,
        'traffic congestion': '-',
        'total': 5.47
    },
    {
        'rank': 44,
        'city': 'Plymouth',
        'co2': 7.56,
        'energy': 8.56,
        'air quality': 7.33,
        'recycling': 3.25,
        'fly tipping': 0,
        'litter': 8.58,
        'green space': 6.67,
        'nature reserves': 1.94,
        'car charging': 3.33,
        'traffic congestion': 7.37,
        'total': 5.46
    },
    {
        'rank': 45,
        'city': 'Stoke-on-Trent',
        'co2': 6.7,
        'energy': 7.85,
        'air quality': 5.78,
        'recycling': 3.5,
        'fly tipping': 7.58,
        'litter': 9.1,
        'green space': 2.22,
        'nature reserves': 2.26,
        'car charging': 2.58,
        'traffic congestion': 6.9,
        'total': 5.45
    },
    {
        'rank': 46,
        'city': 'Cardiff',
        'co2': 6.54,
        'energy': 7.6,
        'air quality': 5.45,
        'recycling': 9.1,
        'fly tipping': 8.19,
        'litter': 0,
        'green space': 7.37,
        'nature reserves': 1.94,
        'car charging': 2.8,
        'traffic congestion': '-',
        'total': 5.44
    },
    {
        'rank': 47,
        'city': 'Chester',
        'co2': 0,
        'energy': 0,
        'air quality': 7.67,
        'recycling': 9.05,
        'fly tipping': 10,
        'litter': 9.26,
        'green space': 6.67,
        'nature reserves': 1.94,
        'car charging': 0.75,
        'traffic congestion': 8.98,
        'total': 5.43
    },
    {
        'rank': 48,
        'city': 'Birmingham',
        'co2': 7.31,
        'energy': 8.34,
        'air quality': 3.23,
        'recycling': 0,
        'fly tipping': 8.05,
        'litter': 4.63,
        'green space': 4.44,
        'nature reserves': 6.77,
        'car charging': 5.81,
        'traffic congestion': 5.67,
        'total': 5.42
    },
    {
        'rank': 49,
        'city': 'Portsmouth',
        'co2': 7.24,
        'energy': 8.29,
        'air quality': 5.07,
        'recycling': 0.86,
        'fly tipping': 9.36,
        'litter': 9.36,
        'green space': 1.25,
        'nature reserves': 1.61,
        'car charging': 4.73,
        'traffic congestion': 5.89,
        'total': 5.37
    },
    {
        'rank': 50,
        'city': 'Newport',
        'co2': 4.41,
        'energy': 6.02,
        'air quality': 7.11,
        'recycling': 9.02,
        'fly tipping': 7.75,
        'litter': 6.41,
        'green space': 2.22,
        'nature reserves': 3.87,
        'car charging': 1.08,
        'traffic congestion': '-',
        'total': 5.32
    },
    {
        'rank': 51,
        'city': 'Manchester',
        'co2': 7.2,
        'energy': 8.29,
        'air quality': 2.99,
        'recycling': 4.43,
        'fly tipping': 5.41,
        'litter': 4.63,
        'green space': 3.49,
        'nature reserves': 2.58,
        'car charging': 10,
        'traffic congestion': 4.17,
        'total': 5.32
    },
    {
        'rank': 52,
        'city': 'Wolverhampton',
        'co2': 7.27,
        'energy': 8.33,
        'air quality': 0,
        'recycling': 3.94,
        'fly tipping': 8.87,
        'litter': 9.11,
        'green space': 4.44,
        'nature reserves': 1.61,
        'car charging': 2.58,
        'traffic congestion': 5.64,
        'total': 5.18
    },
    {
        'rank': 53,
        'city': 'London',
        'co2': 7.6,
        'energy': 8.63,
        'air quality': 0.15,
        'recycling': 2.79,
        'fly tipping': 5.19,
        'litter': '-',
        'green space': 7.21,
        'nature reserves': 4.84,
        'car charging': 10,
        'traffic congestion': 0,
        'total': 5.16
    },
    {
        'rank': 54,
        'city': 'Sheffield',
        'co2': 7.18,
        'energy': 8.18,
        'air quality': 5.14,
        'recycling': 2.2,
        'fly tipping': 6.58,
        'litter': 0.62,
        'green space': 8.15,
        'nature reserves': 4.19,
        'car charging': 2.15,
        'traffic congestion': 7.01,
        'total': 5.14
    },
    {
        'rank': 55,
        'city': 'Sunderland',
        'co2': 6.02,
        'energy': 7.04,
        'air quality': 8.95,
        'recycling': 1.25,
        'fly tipping': 5.76,
        'litter': 5.05,
        'green space': 0,
        'nature reserves': 2.58,
        'car charging': 5.27,
        'traffic congestion': 9.06,
        'total': 5.1
    },
    {
        'rank': 56,
        'city': 'Armagh',
        'co2': 4.84,
        'energy': 7.76,
        'air quality': 6.67,
        'recycling': 7.14,
        'fly tipping': '-',
        'litter': 10,
        'green space': 3.33,
        'nature reserves': 0.32,
        'car charging': 0,
        'traffic congestion': '-',
        'total': 5.01
    },
    {
        'rank': 57,
        'city': 'Southampton',
        'co2': 7.87,
        'energy': 8.87,
        'air quality': 4.82,
        'recycling': 1.78,
        'fly tipping': 4.01,
        'litter': 4.05,
        'green space': 6.67,
        'nature reserves': 3.23,
        'car charging': 2.37,
        'traffic congestion': 5.17,
        'total': 4.88
    },
    {
        'rank': 58,
        'city': 'Bradford',
        'co2': 7.13,
        'energy': 8.1,
        'air quality': 1.33,
        'recycling': 4.28,
        'fly tipping': 5.94,
        'litter': 8.07,
        'green space': 2,
        'nature reserves': 0.97,
        'car charging': 2.58,
        'traffic congestion': 6.9,
        'total': 4.73
    },
    {
        'rank': 59,
        'city': 'Perth',
        'co2': 5.23,
        'energy': 5.48,
        'air quality': 1.33,
        'recycling': 8.22,
        'fly tipping': '-',
        'litter': 8.83,
        'green space': 1.11,
        'nature reserves': 0,
        'car charging': 1.08,
        'traffic congestion': '-',
        'total': 3.91
    }
];
